import React, {Component} from 'react';
import {Row, Col, Form, FormGroup, ControlLabel, Checkbox} from "react-bootstrap";
import {TopButtonAction} from "../../../../../componentsTopsa/buttons/TopButtons";
import {TopSelect} from "../../../../../componentsTopsa/selects/TopSelects";
import ValidatorMessages from "../../../../../shared/validatorMessages/ValidatorMessages";
import TopDostepnosc from "../../../../../componentsTopsa/dostepnosc/TopDostepnosc";


export default class DefinicjaGodzinyStartowejKopiowanieForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            trasa_z: null,
            trasa_do: null,
            kalendarz_z: null,
            kalendarz_do: null,
            czyUsuwacStare: false,
            validatorMessages:[]
        };
        this.onChangeCheckbox = this.onChangeCheckbox.bind(this)
        this.onChangeTrasaZ = this.onChangeTrasaZ.bind(this)
        this.onChangeKalendarzZ = this.onChangeKalendarzZ.bind(this)
        this.onChangeTrasaDo = this.onChangeTrasaDo.bind(this)
        this.onChangeKalendarzDo = this.onChangeKalendarzDo.bind(this)
        this.onClickKopiuj = this.onClickKopiuj.bind(this)
    }

    formatTrasaSelect(option) {
        return <div><span className={'label label-ebus-default'}>{option.kodTrasy}</span> {option.nazTr} <TopDostepnosc wartoscWarunek={0} wartosc={option.status} czyMarginesLewy={true}/></div>
    }

    onChangeCheckbox(e) {
        this.setState({czyUsuwacStare: !this.state.czyUsuwacStare})
    }

    onChangeTrasaZ(e) {
        this.setState({trasa_z: e})
    }

    onChangeKalendarzZ(e) {
        this.setState({kalendarz_z: e})
        if (this.state.kalendarz_do === null) {
            this.setState({kalendarz_do: e})
        }
    }

    onChangeTrasaDo(e) {
        this.setState({trasa_do: e})
    }

    onChangeKalendarzDo(e) {
        this.setState({kalendarz_do: e})
    }

    dodajDoValidatorMessages(msg) {
        let arr = this.state.validatorMessages;
        arr.push(msg)
        this.setState({validatorMessages: arr})
    }

    onClickKopiuj() {

        let poprawne = true; this.state.validatorMessages = [];

        if(!Boolean(this.state.trasa_z)){
            poprawne = false;
            this.dodajDoValidatorMessages('Nie wybrano trasy do skopiowania')
        }

        if(!Boolean(this.state.trasa_do)){
            poprawne = false;
            this.dodajDoValidatorMessages('Nie wybrano trasy docelowej')
        }

        if(!Boolean(this.state.kalendarz_z)){
            poprawne = false;
            this.dodajDoValidatorMessages('Nie wybrano kalendarza do skopiowania')
        }

        if(!Boolean(this.state.kalendarz_do)){
            poprawne = false;
            this.dodajDoValidatorMessages('Nie wybrano kalendarza docelowego')
        }

        if (poprawne) {

            this.setState({validatorMessages:[]})

            let czyUsuwac = 0;
            if (this.state.czyUsuwacStare) {
                czyUsuwac = 1
            }

            let data = {idTrNa: this.state.trasa_do.idTr, idRkNa: this.state.kalendarz_do.idRk}

            let params = '?idTrZ=' + this.state.trasa_z.idTr +
                '&idRkZ=' + this.state.kalendarz_z.idRk +
                '&idTrNa=' + this.state.trasa_do.idTr +
                '&idRkNa=' + this.state.kalendarz_do.idRk +
                '&czyUsuwacStare=' + czyUsuwac;

            this.props.handleClickKopiuj(data, params);
        }
    }

    render() {

        return (
            <div>
                <Row>
                    <Col xs={12} md={12} lg={7}>
                        <Form horizontal={true}>
                            <FormGroup>
                                <Col xs={12} md={6} lg={6}>
                                    <ControlLabel>Wybierz trasę do skopiowania <span className={'req'}>*</span></ControlLabel>
                                    <TopSelect onChange={this.onChangeTrasaZ} value={this.state.trasa_z} options={this.props.trasy}
                                               valueKey={'idTr'} labelKey={'nazTr'}
                                               valueRenderer={this.formatTrasaSelect} optionRenderer={this.formatTrasaSelect}
                                    />
                                </Col>
                                <Col xs={12} md={6} lg={6}>
                                    <ControlLabel>Wybierz kalendarz do skopiowania <span className={'req'}>*</span></ControlLabel>
                                    <TopSelect onChange={this.onChangeKalendarzZ} value={this.state.kalendarz_z} options={this.props.kalendarze}
                                               valueKey={'idRk'} labelKey={'nazRk'}
                                    />
                                </Col>
                            </FormGroup>
                            <FormGroup>
                                <Col xs={12} md={6} lg={6}>
                                    <ControlLabel>Wybierz trasę docelową <span className={'req'}>*</span></ControlLabel>
                                    <TopSelect onChange={this.onChangeTrasaDo} value={this.state.trasa_do} options={this.props.trasy}
                                               valueKey={'idTr'} labelKey={'nazTr'}
                                               valueRenderer={this.formatTrasaSelect} optionRenderer={this.formatTrasaSelect}
                                    />
                                </Col>
                                <Col xs={12} md={6} lg={6}>
                                    <ControlLabel>Wybierz kalendarz docelowy <span className={'req'}>*</span></ControlLabel>
                                    <TopSelect onChange={this.onChangeKalendarzDo} value={this.state.kalendarz_do} options={this.props.kalendarze}
                                               valueKey={'idRk'} labelKey={'nazRk'}
                                    />
                                </Col>
                            </FormGroup>
                            <FormGroup>
                                <Col xs={12}>
                                    <Checkbox onChange={this.onChangeCheckbox} inline={true}>
                                        Czy usunąć istniejące rekordy z tabeli docelowej?
                                        - <span
                                        style={(this.state.czyUsuwacStare) ? {color: 'red'} : {}}>{(this.state.czyUsuwacStare) ? 'TAK' : 'NIE'}</span>
                                    </Checkbox>
                                    <div className={'pull-right'}>

                                        <TopButtonAction iconType={'fa fa-copy'} text={'Kopiuj'} onClick={this.onClickKopiuj} btnSize={'medium'}
                                                         btnColor={'warning'}/>
                                    </div>
                                </Col>
                            </FormGroup>
                            <FormGroup>
                                <ValidatorMessages messages={this.state.validatorMessages}/>
                            </FormGroup>
                        </Form>
                    </Col>
                </Row>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/definicjeGodzinStartowychjDlaTrasy/components/DefinicjaGodzinyStartowejKopiowanieForm.js